$(document).ready(function() {
  $(function () {
    $('.open-date').datepicker({
      format: 'dd/mm/yyyy'
    });

    $('.start-date').datepicker({
      format: 'dd/mm/yyyy'
    });

    $('.end-date').datepicker({
      format: 'dd/mm/yyyy',
      endDate: '0d'
    });
  });
});
